import { css } from 'styled-components'

export default ({ objectFit, objectPosition, filter }) => css`
  object-fit: ${objectFit};
  object-position: ${objectPosition};
  filter: ${filter};
`
